import { useState } from "react";
import { useTranslation } from "react-i18next";
// Functions
import { protocols } from "../../../../../../config/constants";
// Components
import {
  ProtocolLevelDiv,
  HeaderDiv,
  ControlText,
  ProtocolLevelAlignerDiv,
  LevelCheckboxDiv,
  InputCheckboxDiv,
  InputCheckbox,
  VerifyCheckboxImg,
  DurationSelect,
} from "./styles";
// Assets
import CheckFalse from "../../../../../../assets/icons/ico_checkbox_false.svg";
import CheckTrue from "../../../../../../assets/icons/ico_checkbox_true.svg";

const ProtocolLevels = ({ protocolId, protocolControlsToSave, setProtocolControlsToSave }) => {
  const [twisterBuddyLevels] = useState([
    {
      key: "level_1",
      label: "twisterBuddy_level_1",
    },
    {
      key: "level_2",
      label: "twisterBuddy_level_2",
    },
    {
      key: "level_3",
      label: "twisterBuddy_level_3",
    },
    {
      key: "level_4",
      label: "twisterBuddy_level_4",
    },
    {
      key: "level_5",
      label: "twisterBuddy_level_5",
    },
  ]);
  const [costumePartyLevels] = useState([
    {
      key: "level_1",
      label: "costumeParty_level_1",
    },
    {
      key: "level_2",
      label: "costumeParty_level_2",
    },
    {
      key: "level_3",
      label: "costumeParty_level_3",
    },
  ]);
  const [gentleGiantLevels] = useState([
    {
      key: "level_1",
      label: "gentleGiant_level_1",
    },
    {
      key: "level_2",
      label: "gentleGiant_level_2",
    },
  ]);

  const [t] = useTranslation("global");

  const validateControl = (levelKey) => {
    const protocolControl = protocolControlsToSave[levelKey] || false;
    return protocolControl && !protocolControl.DELETE_TIME;
  };

  const getControlValue = (levelKey) => {
    const protocolControl = protocolControlsToSave[levelKey] || { CONTROL_VALUE: "60" };
    return protocolControl.CONTROL_VALUE;
  };

  const prescriptionMinutes = Array.from({ length: 10 }, (_, i) => (
    <option key={i} value={(i + 1) * 60}>
      {i + 1} min
    </option>
  ));

  const renderProtocolLevels = () => {
    const protocolLevelsMapping = {
      [protocols.web.fullBody.TWISTER_BUDDY.id]: twisterBuddyLevels,
      [protocols.web.fullBody.COSTUME_PARTY.id]: costumePartyLevels,
      [protocols.web.fullBody.GENTLE_GIANT.id]: gentleGiantLevels,
    };
    const protocolLevels = protocolLevelsMapping[protocolId] || [];

    return protocolLevels.map((level) => {
      const isTheControlActive = validateControl(level.key);
      const controlValue = getControlValue(level.key);

      const setProtocolControl = (controlValueToSet) => {
        let protocolControlToAdd = {
          CONTROL_VALUE: controlValueToSet ? controlValueToSet : controlValue,
        };

        if (isTheControlActive && !controlValueToSet) protocolControlToAdd.DELETE_TIME = new Date();

        setProtocolControlsToSave((prevState) => ({
          ...prevState,
          [level.key]: protocolControlToAdd,
        }));
      };

      return (
        <ProtocolLevelAlignerDiv key={level.key}>
          <LevelCheckboxDiv>
            <InputCheckboxDiv>
              <InputCheckbox type="checkbox" id={level.key} value={isTheControlActive} onClick={() => setProtocolControl()} />
              {isTheControlActive ? (
                <VerifyCheckboxImg src={CheckTrue} alt="check-true" />
              ) : (
                <VerifyCheckboxImg src={CheckFalse} alt="check-false" />
              )}
            </InputCheckboxDiv>
            <ControlText fontSize="12px">{t(level.label)}</ControlText>
          </LevelCheckboxDiv>
          <DurationSelect value={controlValue} onChange={(e) => setProtocolControl(e.target.value)} disabled={!isTheControlActive}>
            {prescriptionMinutes}
          </DurationSelect>
        </ProtocolLevelAlignerDiv>
      );
    });
  };

  return (
    <ProtocolLevelDiv>
      <HeaderDiv>
        <ControlText>{t("controls_levelsSelection")}</ControlText>
        <ControlText>{t("duration")}</ControlText>
      </HeaderDiv>
      {renderProtocolLevels()}
    </ProtocolLevelDiv>
  );
};

export default ProtocolLevels;
